export const ModelUploadImage = (obj = {}) => {
	return {
		imageId: obj.fileId || '',
		imagePath: obj.filePath || '',
	}
}
